import { User, UserTenantAttribute } from "../../_objects/user";

export interface LoginUserContractService {
  loginUser: User;
  tenantAttribute: UserTenantAttribute;
  tenantId: string;
  userId: string;

  isAdminRole(): boolean;
  isTenantAdminRole(): boolean;
}

export abstract class LoginUserServiceBase implements LoginUserContractService {
  protected _loginUser: User;
  protected _tenantAttribute: UserTenantAttribute;
  protected _organizationId: string;
  protected _isAdminRole = false;

  public get loginUser(): User {
    return this._loginUser;
  }

  public get userId() {
    return this.loginUser?.id;
  }

  public set loginUser(user: User) {
    if (!user) {
      throw new Error("Invalid user provided.");
    }
    this._loginUser = user;
  }

  public get tenantId(): string {
    return this._tenantAttribute?.id;
  }

  public get tenantAttribute(): UserTenantAttribute {
    return this._tenantAttribute;
  }

  public async setTenantAndUserProfile() {
    this._tenantAttribute = this.getDefaultTenantAttribute();
    await this.loadUserProfile();
  }

  public isAdminRole(): boolean {
    const userRole = this.getDefaultTenantAttribute()?.role;

    if (userRole === "Admin" || userRole === "Owner")
      this._isAdminRole = true;

    return this._isAdminRole;
  }

  public isTenantAdminRole(): boolean {
    return this.isAdminRole();
  }

  protected getDefaultTenantAttribute(): UserTenantAttribute {
    let tenantAttribute: UserTenantAttribute;
    if (
      this.loginUser &&
      this.loginUser.tenantAttributes &&
      0 < this.loginUser.tenantAttributes.length
    ) {
      tenantAttribute = this.loginUser.tenantAttributes[0];
    }
    return tenantAttribute;
  }

  protected abstract loadUserProfile(): Promise<void>;
}
